import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { getCurrentCycle } from 'entity/reward/rewardTypes';
import { useSelector } from 'react-redux';
import { RootState } from 'reducer';

dayjs.extend(isBetween);

const useShowNotification = () => {
  const currentCycle = getCurrentCycle();
  const profile = useSelector((state: RootState) => state.profile.user);
  const { openRewardCycleNotifAt } = profile;

  let title = '';
  let description = '';
  let cta = '';

  if (!openRewardCycleNotifAt) {
    return {
      title,
      description,
      cta,
      showAlert: false,
    };
  }

  const startCycle = dayjs(currentCycle[0]);
  const endCycle = dayjs(currentCycle[1]);
  const openRewardAt = dayjs(openRewardCycleNotifAt);
  const today = dayjs(new Date());

  const monthLeft = [endCycle.subtract(31, 'day'), endCycle.subtract(7, 'day')];
  const weekLeft = [endCycle.subtract(7, 'day'), endCycle];
  const newCycle = [startCycle, startCycle.add(31, 'day')];

  const isMonthLeft = today.isBetween(monthLeft[0], monthLeft[1]);
  const isWeekLeft = today.isBetween(weekLeft[0], weekLeft[1]);
  const isNewCycle = today.isBetween(newCycle[0], newCycle[1]);

  const openedMonth = openRewardAt.isBetween(monthLeft[0], monthLeft[1]);
  const openedWeek = openRewardAt.isBetween(weekLeft[0], weekLeft[1]);
  const openedNew = openRewardAt.isBetween(newCycle[0], newCycle[1]);

  const showMonth = isMonthLeft && !openedMonth;
  const showWeek = isWeekLeft && !openedWeek;
  const showNew = isNewCycle && !openedNew;
  const showAlert = showMonth || showWeek || showNew;

  if (isMonthLeft) {
    title = `🔔 Ding ding! Your tier will reset on ${endCycle.format(
      'DD MMM YYYY',
    )}.`;
    description =
      'Let’s work to maintain your tier or even climb to the next tier!';
    cta = 'Find out more.';
  }

  if (isWeekLeft) {
    title = `⏰ Time’s ticking…your tier will reset on ${endCycle.format(
      'DD MMM YYYY',
    )}.`;
    description =
      'Have a quick look at your current tier and what to expect next!';
    cta = 'Find out more.';
  }

  if (isNewCycle) {
    title = '✨ Hooray! We’re in a new reward cycle!';
    description = 'Check out your new tier and available rewards!';
    cta = 'Let’s go!';
  }

  return {
    title,
    description,
    cta,
    showAlert,
  };
};

export default useShowNotification;
